var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"search",staticClass:"modal-input",attrs:{"placeholder":"Search...","type":"text"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.$emit('close')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }